module.exports = __webpack_public_path__ + "static/media/BTS_FINALS-3.5f841988.jpg";